import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/icon-plus-hold.svg'
import _imports_1 from '@/assets/icons/icon-minus-hold.svg'


const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = { class: "hold-duration-text" }
const _hoisted_4 = { class: "hold-input-wr" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "buttons-wrapper" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.onClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString($setup.props.customTitle ?? "Hold Duration"), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString($setup.modalText), 1),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text" }, "Day(s)", -1)),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "input-large input-days",
            type: "text",
            placeholder: $setup.props.minExpirationDays,
            maxlength: "2",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.expirationDateForm) = $event))
          }, null, 8, _hoisted_5), [
            [_vModelText, $setup.expirationDateForm]
          ]),
          _createElementVNode("img", {
            class: "input-large icon-plus",
            src: _imports_0,
            name: "plus",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onDaysChange($event)))
          }),
          _createElementVNode("img", {
            class: "input-large icon-minus",
            src: _imports_1,
            name: "minus",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onDaysChange($event)))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "button",
            onClick: $setup.onClose
          }, "Cancel"),
          _createElementVNode("button", {
            class: _normalizeClass(["button primary", { disabled: $props.isSubmitting }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.submit($setup.expirationDateForm))),
            disabled: $props.isSubmitting
          }, _toDisplayString($setup.buttonText), 11, _hoisted_7)
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}